//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    var bodyEl = document.body
    var top = 0
    function stopBodyScroll (isFixed) {
      if (isFixed) {
        top = window.scrollY
        bodyEl.style.width = '100%'
        bodyEl.style.position = 'fixed'
        bodyEl.style.top = -top + 'px'
      } else {
        bodyEl.style.position = ''
        bodyEl.style.top = ''

        window.scrollTo(0, top) // 回到原先的top
      }
    }
    export default {
        name: 'mt-dropdown-menus',
        data () {
            return {
              itemWidth:'',
              shadowTop:'',
              maxHeight:'',
              height:'',
              selectedStorage: -1
            }
        },
        props:{
            options:{type:Array,default:[]},
            isShowMenu: {
                type: Boolean,
                default: false
            }
        },

        watch:{
          options:function(n){
            if(n.length){
              this.itemWidth = (100 / n.length) + '%';
            }else {
              console.log('按钮组长度为0')
            }
          },
          isShowMenu: function(n){
            //debugger
            if(n){
              this.$nextTick(function(){
                this.setContentHeight()
              })
            }else{
              stopBodyScroll(false)
              // this.height = 0;
            }
          }
        },

        components:{
            
        },
        created() {
          var that = this
            if(this.options.length){
              this.itemWidth = (100 / this.options.length) + '%';
            }
        },
        mounted(){
          var that = this
          var observe=new MutationObserver(function (mutations,observe) {
              that.setContentHeight()
          });
          observe.observe(document.getElementsByClassName('bh-ddm')[0],{ childList: true,subtree: true});
        },
        methods:{
            setContentHeight:function(){
              let elem = this.$refs.content;
              let obj = {
                "top":elem.offsetTop
              };
              console.log(obj.top)
              while(elem && elem != document.body){
                elem = elem.offsetParent;
                if(elem !== null){
                  if(elem.offsetParent){
                    //判断elem的position是否等于'fixed'
                    obj.top += elem.offsetTop;
                  }
                }
              }
              this.shadowTop = obj.top + "px";
              console.log(this.shadowTop)
              var contentVisibleHeight = window.innerHeight - obj.top;
              //var contentVisibleHeight = window.screen.height - obj.top;
              //this.maxHeight = contentVisibleHeight + "px";
              var contentEle = document.getElementsByClassName('bh-ddm')[0].children;
              if (contentEle.length>0) {
                var contentHeight = document.getElementsByClassName('bh-ddm')[0].children[0].offsetHeight;
                if (contentHeight > contentVisibleHeight) {
                  this.height = contentVisibleHeight + 'px';
                  this.shadowTop = obj.top + contentVisibleHeight + 'px';
                } else {
                  this.height = contentHeight + 'px';
                  this.shadowTop = obj.top + contentHeight + 'px';
                }
              }
            },
            setSelected:function(param,index,evt){
                if(this.selectedStorage>-1 && this.selectedStorage === index && param.active){
//                  this.$nextTick(function(){
//                    this.$set(param,'active',false);
//                  })
                  this.selectedStorage = -1;
                  this.$emit('selected-self',false)

                    //当该项处于展开状态，再次点击后，该项收起    RES-329
                    this.cancelShadow();
                  return
                }else{
                  this.selectedStorage = index;
                }
                
                var that = this;
                that.$nextTick(function () {
                    that.options.forEach(function (item) {
                    that.$set(item,'active',false);
                  });
                  that.$set(param,'active',true);
                  that.$set(param,'index',index);
                  that.$emit('dropDown',param,evt);
                });
                console.log('----------------stopBodyScroll(true)')
                stopBodyScroll(true)
            },
            cancelShadow: function(evt) {
              this.options.forEach(function(ele) {
                if (ele.active) {
                  ele.active = false;
                }
              });
              this.borderActive=false;
              //this.isShowMenu = false;
              this.$emit('cancel', evt);
            }
        },
        beforeDestroy:function(){
          stopBodyScroll(false)
        }
    }



// WEBPACK FOOTER //
// ./packages/dropdown-menus/src/dropdown-menus.vue